import { z } from "zod";

export const menuLayoutSchema = z.object({
  name: z
    .string()
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name must not exceed 100 characters"),
  description: z
    .string()
    .max(500, "Description must not exceed 500 characters")
    .optional()
    .or(z.literal("")),
  image: z
    .string()
    .url("Please upload a valid image")
    .min(1, "Image is required"),
});

export const defaultMenuLayoutValues = {
  name: "",
  description: "",
  image: "",
};
